// Subpath import: must not use the bare "moment" specifier (Vite alias previously caused a circular load).
import moment from 'moment/moment.js'
import 'moment-timezone'
import * as momentRangeModule from 'moment-range'

const extendMoment =
  momentRangeModule.extendMoment ??
  (momentRangeModule.default && momentRangeModule.default.extendMoment)

if (typeof extendMoment !== 'function') {
  const keys = Object.keys(momentRangeModule).join(', ')
  throw new Error(
    `[moment] moment-range: extendMoment is not a function (module keys: ${keys || 'none'})`
  )
}

const momentExtended = extendMoment(moment)

momentExtended.updateLocale('en', {
  week: { dow: 1 } // Monday is the first day of the week
})

export default momentExtended
